import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState, useEffect } from "react";
import MarkdownRenderer from "../../MarkdownRenderer";
import { convertMdxToMd } from "../../../lib/convertMdx";
import kycOverviewFile from "../../../assets/markDownFiles/id/id.md";

const KycOverview = () => {
  const [content, setContent] = useState("");
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  useEffect(() => {
    if (typeof kycOverviewFile === "string" && kycOverviewFile.startsWith("/static")) {
      fetch(kycOverviewFile)
        .then((res) => res.text())
        .then((raw) => setContent(convertMdxToMd(raw)));
    } else {
      setContent(convertMdxToMd(kycOverviewFile));
    }
  }, []);

  return (
    <Box sx={{ padding: "0" }}>
      <Typography
        sx={{
          color: "#e54f9c",
          fontWeight: "900",
          fontSize: "0.8rem",
          marginBottom: "0.35rem",
          marginLeft: isDesktop ? "0" : "5%",
        }}
      >
        ACT ID (KYC)
      </Typography>
      {content ? (
        <MarkdownRenderer content={content} />
      ) : (
        <p>Loading...</p>
      )}
    </Box>
  );
};

export default KycOverview;

